import { resource } from "./resource";

/**
 * Employee documents and HR's verification of them. HR verifies every
 * document: one is submitted until somebody verifies it or returns it with a
 * reason.
 */
const api = resource("/document");

// HR's queue. status: "submitted" (default) | "verified" | "returned".
export const getDocumentQueue = async (status = "submitted") => await api.get(`?status=${status}`);
export const getEmployeeDocuments = async (employeeId) => await api.get(`/employee/${employeeId}`);
export const verifyDocument = async (id) => await api.post(`/${id}/verify`, {});
export const returnDocument = async (id, reason) => await api.post(`/${id}/return`, { reason });

/** A five-minute signed link — the stored address is in a private bucket. */
export const getDocumentFileUrl = async (id) => await api.get(`/${id}/file`);

export const DOCUMENT_TYPE_LABELS = {
  pan: "PAN card",
  aadhaar_masked: "Aadhaar (masked)",
  passport: "Passport",
  visa: "Visa",
  oci: "OCI card",
  address_proof: "Address proof",
  bank_proof: "Bank proof",
  education: "Education",
  experience: "Experience",
  photo: "Photo",
  other: "Other",
};
